// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EH0lE{position:relative;height:100%}.Tw1QY{position:absolute;top:16px;right:16px;z-index:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EH0lE`,
	"closeButton": `Tw1QY`
};
export default ___CSS_LOADER_EXPORT___;
